import "esbuild-css-modules-plugin-ns-css:src/artifacts/dashboard/styles/list.module.css";

export default {
  "card": "list-module__card_B6U6iG__010",
  "cardActions": "list-module__cardActions_B6U6iG__010",
  "empty": "list-module__empty_B6U6iG__010",
  "errorBanner": "list-module__errorBanner_B6U6iG__010",
  "header": "list-module__header_B6U6iG__010",
  "list": "list-module__list_B6U6iG__010",
  "notice": "list-module__notice_B6U6iG__010",
  "page": "list-module__page_B6U6iG__010",
  "stat": "list-module__stat_B6U6iG__010",
  "statLabel": "list-module__statLabel_B6U6iG__010",
  "statUnit": "list-module__statUnit_B6U6iG__010",
  "statValue": "list-module__statValue_B6U6iG__010",
  "subtitle": "list-module__subtitle_B6U6iG__010",
  "type": "list-module__type_B6U6iG__010"
};
      